import { t } from '@/features/i18n/utils';
import { useWorkspace } from '@/features/workspaces/helpers';
import { createFileRoute } from '@tanstack/react-router';
import { WorkspaceTypeIcon } from '@/features/workspaces/components/workspace-type-icon';
import { Breadcrumb, BreadcrumbLink, BreadcrumbPage } from '@/ui/components/breadcrumb';
import { Header, HeaderChatButton, HeaderBackButton } from '@/ui/components/header';
import { H1 } from '@/ui/components/heading';
import { MainContainer, MainHeader, MainScrollArea } from '@/ui/components/main';
import { Sidenav, SidenavItem, SidenavLink, SidenavList } from '@/ui/components/sidenav';
import { SettingsIcon } from '@hugeicons-pro/core-stroke-rounded';
import { Icon } from '@/ui/components/icon';
import { Outlet } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authed/project/$projectId/workspaces/$workspaceId/_layout/settings',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { projectId, workspaceId } = Route.useParams();
  const workspace = useWorkspace();

  return (
    <>
      <Header>
        <HeaderBackButton />
        <Breadcrumb>
          <BreadcrumbLink
            to="/project/$projectId/workspaces/$workspaceId"
            params={{ projectId, workspaceId }}
          >
            <WorkspaceTypeIcon type={workspace.type} />
            <span className="line-clamp-1">{workspace.name}</span>
          </BreadcrumbLink>
          <BreadcrumbPage>
            <Icon icon={SettingsIcon} />
            {t({ en: 'Settings', nb: 'Innstillinger' })}
          </BreadcrumbPage>
        </Breadcrumb>
        <HeaderChatButton />
      </Header>
      <MainScrollArea>
        <MainHeader className="max-md:hidden">
          <H1>{t({ en: 'Settings', nb: 'Innstillinger' })}</H1>
        </MainHeader>
        <div className="flex flex-col @3xl:flex-row">
          <Sidenav className="@3xl:sticky top-0 h-fit">
            <SidenavList className="p-4">
              <SidenavItem>
                <SidenavLink
                  to="/project/$projectId/workspaces/$workspaceId/settings"
                  params={{ projectId, workspaceId }}
                >
                  {t({ en: 'General', nb: 'Generelt' })}
                </SidenavLink>
              </SidenavItem>
            </SidenavList>
          </Sidenav>
          <MainContainer>
            <Outlet />
          </MainContainer>
        </div>
      </MainScrollArea>
    </>
  );
}
